/**
 * JULEPS - Collections Grid JavaScript
 * Gère l'interaction hover/clic pour ouvrir/fermer les cartes de collections
 */

class JulepsCollectionsGrid {
  constructor(container) {
    this.container = container;
    this.cards = container.querySelectorAll('.juleps-collections-grid__card');
    this.init();
  }

  init() {
    this.cards.forEach(card => {
      // Bouton d'ouverture (chevron bas)
      const openButton = card.querySelector('.juleps-collections-grid__toggle');
      if (openButton) {
        openButton.addEventListener('click', () => this.openCard(card));
      }

      // Bouton de fermeture (chevron haut)
      const closeButton = card.querySelector('.juleps-collections-grid__toggle-close');
      if (closeButton) {
        closeButton.addEventListener('click', () => this.closeCard(card));
      }

      // Optionnel : Ouvrir au hover (décommenter si souhaité)
      // card.addEventListener('mouseenter', () => this.openCard(card));
      // card.addEventListener('mouseleave', () => this.closeCard(card));
    });
  }

  openCard(card) {
    // Fermer toutes les autres cartes
    this.cards.forEach(c => {
      if (c !== card) {
        this.closeCard(c);
      }
    });

    // Ouvrir la carte sélectionnée
    card.classList.add('is-open');
  }

  closeCard(card) {
    card.classList.remove('is-open');
  }

  closeAllCards() {
    this.cards.forEach(card => this.closeCard(card));
  }
}

// Initialisation au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  const grids = document.querySelectorAll('.juleps-collections-grid');
  grids.forEach(grid => {
    new JulepsCollectionsGrid(grid);
  });
});

// Réinitialisation lors du changement de section dans l'éditeur de thème
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const grid = event.target.querySelector('.juleps-collections-grid');
    if (grid) {
      new JulepsCollectionsGrid(grid);
    }
  });
}

